<script type="text/babel">
export default {
  name: 'BaseTab',
  render() {
    return this.$slots.default[0]
  },
}
</script>
